// ============================================================
// mainvisualAnimation.js — メインビジュアル訪問時アニメーション
//
// GSAP を使用したシーケンシャルアニメーション
// 1. s-mainvisual__logo + s-mainvisual__shape — 同時に上からフェードイン
// 2. s-main-visual__pic-item                  — 下からフェードイン（ランダム順、stagger）
// 3. s-reserve                                — ふわっとフェードイン
//
// + ScrollTrigger によるシェイプのパララックス
// ============================================================

export function mainvisualAnimation() {
  if (typeof gsap === "undefined") return;

  const logo = document.querySelector(".s-mainvisual__logo");
  const shapeGroup = document.querySelector(".s-mainvisual__shape");
  const shapes = gsap.utils.toArray(".s-main-visual__shape-item");
  const pics = gsap.utils.toArray(".s-main-visual__pic-item");
  const reserve = document.querySelector(".s-reserve");

  if (!logo || !shapeGroup || !shapes.length || !pics.length || !reserve) return;

  // prefers-reduced-motion: アニメーションをスキップし表示のみ
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    gsap.set([logo, shapeGroup, ...pics, reserve], { autoAlpha: 1 });
    return;
  }

  // 初期状態: 非表示
  gsap.set(logo, { autoAlpha: 0 });
  gsap.set(shapeGroup, { autoAlpha: 0, y: -50 });
  gsap.set(pics, { autoAlpha: 0, y: 30 });
  gsap.set(reserve, { autoAlpha: 0 });

  // タイムライン
  const tl = gsap.timeline({
    defaults: { duration: 0.8, ease: "power2.out" },
  });

  // 1. ロゴ — ふわっとフェードイン
  tl.to(logo, {
    autoAlpha: 1,
    duration: 2,
  });

  // 1. Shape グループ — 同時に上からフェードイン
  tl.to(
    shapeGroup,
    {
      autoAlpha: 1,
      y: 0,
      duration: 2,
      onComplete: () => {
        gsap.set(shapeGroup, { clearProps: "transform" });
      },
    },
    "<"
  );

  // 2. Pic — 下からフェードイン（ランダム順、stagger）
  const shuffled = [...pics].sort(() => Math.random() - 0.5);
  tl.to(
    shuffled,
    {
      autoAlpha: 1,
      y: 0,
      duration: 0.8,
      stagger: 0.1,
    },
    "-=0.6"
  );

  // 3. 予約ボタン — ふわっとフェードイン
  tl.to(
    reserve,
    {
      autoAlpha: 1,
      duration: 0.8,
    },
    "-=0.3"
  );

  // ---- スクロールパララックス（shape） ----
  // s-mainvisual は fixed のため、scroll イベント + lerp 補間で慣性付きパララックス
  const speeds = [
    0.02, 0.035, 0.015, 0.04, 0.025, 0.05, 0.03, 0.018,
    0.045, 0.022, 0.038, 0.012, 0.028, 0.042, 0.016, 0.034, 0.048, 0.026,
  ];
  const setY = shapes.map((s) => gsap.quickSetter(s, "y", "px"));
  const currentY = shapes.map(() => 0);
  const targetY = shapes.map(() => 0);
  const ease = 0.04;

  window.addEventListener(
    "scroll",
    () => {
      const scrollY = window.scrollY;
      shapes.forEach((_, i) => {
        targetY[i] = scrollY * speeds[i % speeds.length];
      });
    },
    { passive: true }
  );

  gsap.ticker.add(() => {
    shapes.forEach((_, i) => {
      currentY[i] += (targetY[i] - currentY[i]) * ease;
      setY[i](currentY[i]);
    });
  });
}
